export default "__VITE_ASSET__CfQxmlpJ__"